import React, { useMemo } from 'react';
// import PropTypes from 'prop-types';

import { generateTableHead } from '../../helpers';

const Head = () => {
  const headers = useMemo(() => generateTableHead(), []);

  return (
    <thead>
      <tr>
        {headers.map((head) => (
          <th key={head.title} className={head.class} {...head.attrs}>
            {head.title}
          </th>
        ))}
      </tr>
    </thead>
  );
};

Head.propTypes = {};

export default Head;
